// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"333":"epub","962":"home"}[chunkId] || chunkId) + "." + {"333":"5cd499f8","546":"be030c48","869":"ced27a81","962":"43cd6344"}[chunkId] + ".chunk.js";
};